import './DataTableHeader.css';
export var header = '_1kpe8zs0-3-8-0';
export var headerRow = '_1kpe8zs1-3-8-0';